// client/src/services/supabaseUserManagementService.js
import { supabase } from './supabase';

const supabaseUserManagementService = {
  async getAllUserProfiles(limit, offset) {
    const { data, error } = await supabase.functions.invoke('get-all-user-profiles', {
      body: { limit, offset },
    });

    if (error) {
      return { data: null, error };
    }
    return { data: { profiles: data.profiles, totalCount: data.totalCount }, error: null };
  },

  async getCurrentUserProfile(userId, email) {
    try {
      const { data, error } = await supabase
        .from('user_profiles')
        .select('id, email, role, tier, tournament_limit, created_at')
        .eq('id', userId)
        .single();

      if (error) {
        // Supabaseのsingle()でレコードが見つからない場合のエラーコードは 'PGRST116'
        if (error.code === 'PGRST116') { // レコードが見つからない場合のみプロファイル作成を試みる
          const { data: newProfileData, error: createProfileError } = await supabase.functions.invoke('create-user-profile', {
            body: { id: userId, email: email, role: 'user', tier: 'free', tournament_limit: 3 },
          });

          if (createProfileError) {
            return { data: null, error: createProfileError };
          } else if (newProfileData.success) {
            return { data: newProfileData.profile, error: null };
          } else {
            return { data: null, error: new Error('Unknown error creating profile') };
          }
        } else { // その他のエラーの場合
          return { data: null, error: error };
        }
      }
      return { data: data, error: null };
    } catch (e) {
      return { data: null, error: e };
    }
  },

  async deleteUser(userIdToDelete) {
    const { data, error } = await supabase.functions.invoke('delete-user', {
      body: { userIdToDelete },
    });

    if (error) {
      return { data: null, error: error };
    }
    return { data: { success: data.success }, error: data.error };
  },

  async updateUserTier(userId, newTier) {
    const { data, error } = await supabase.functions.invoke('update-user-tier', {
      body: { userId, newTier },
    });

    if (error) {
      return { data: null, error: error };
    }
    return { data: { success: data.success }, error: data.error };
  },
};

export default supabaseUserManagementService;
